import { useEffect, useState } from 'react';
import { ADMIN_SESSION_EVENT, getAdminToken, getStoredAdminUser } from '@/lib/api';

export function useAuth() {
  const [session, setSession] = useState<{ user: { email: string } } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const syncSession = () => {
      const token = getAdminToken();
      const user = getStoredAdminUser();

      if (token && user) {
        setSession({ user: { email: user.email } });
      } else {
        setSession(null);
      }

      setLoading(false);
    };

    syncSession();
    window.addEventListener('storage', syncSession);
    window.addEventListener(ADMIN_SESSION_EVENT, syncSession);

    return () => {
      window.removeEventListener('storage', syncSession);
      window.removeEventListener(ADMIN_SESSION_EVENT, syncSession);
    };
  }, []);

  return { session, loading };
}
